import CommonLayout from 'layouts/DashboardLayout'
import React, { useEffect, useMemo } from 'react'
import SliderBanner from './SliderBanner'
import { useSearchParams } from 'react-router-dom';
import HolidaysHome from './Holidays/HolidaysHome';
import BrbHome from './BRB/BRBHome';
import { Box } from '@mui/material';
import HomepageBanner from './HomepageBanner/HomepageBanner';

const HomeBannerManage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);

    useEffect(() => {
        // homepageBanner
        setSearchParams({ roleTab: fullRoleTab ? fullRoleTab : 'homepageBanner' })

    }, [fullRoleTab])

    return (
        <CommonLayout>
            <Box display="flex" alignItems="start" gap={2.5} p={{ xs: 2, sm: 3, lg: 4 }} pb={{ lg: 2 }}>
                <SliderBanner />
                <Box flex="1">
                    {(fullRoleTab === 'homepageBanner') ? (
                        <HomepageBanner />
                    ) : fullRoleTab === 'brbHome' ? (
                        <BrbHome />
                    ) : fullRoleTab === 'holidaysHome' ? (
                        <HolidaysHome />
                    ) : null}
                </Box>
            </Box>
        </CommonLayout>
    )
}

export default HomeBannerManage
